<template>
	<div class="encryption-type-selector">
		<div
			class="text-subtitle-2 mb-2"
		>
			Encryption Type
		</div>
		<v-row dense>
			<v-col
				v-for="type in displayTypes"
				:key="type.id"
				cols="6"
			>
				<v-card
					outlined
					:class="[
						'type-card',
						{ 'type-card--selected': value === type.id }
					]"
					@click="$emit('input', type.id)"
				>
					<v-card-text
						class="text-center pa-4"
					>
						<v-icon
							:size="32"
							class="mb-2"
						>
							{{ type.icon }}
						</v-icon>
						<div class="text-subtitle-1 font-weight-medium">
							{{ type.label }}
						</div>
						<v-icon
							v-if="value === type.id"
							color="primary"
							class="selected-badge"
							small
						>
							mdi-check-circle
						</v-icon>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'encryption-type-selector',

	props: {
		value: {
			type: Number,
			required: true
		},
		types: {
			type: Array,
			default: function () {
				return []
			}
		}
	},

	computed: {
		displayTypes: function () {
			// Use API types if available, otherwise fall back to defaults
			if (this.types && this.types.length > 0) {
				return this.types.map(function (type) {
					return {
						id: type.encryptionTypeId,
						icon: type.encryptionTypeId === 1 ? 'mdi-key' : 'mdi-salesforce',
						label: type.encryptionTypeName
					}
				})
			}
			// Default fallback if types not loaded
			return [
				{
					id: 1,
					icon: 'mdi-key',
					label: 'Default'
				},
				{
					id: 2,
					icon: 'mdi-salesforce',
					label: 'Salesforce Marketing Cloud',
					shortLabel: 'SFMC'
				}
			]
		}
	}
}
</script>

<style scoped>
.type-card {
	cursor: pointer;
	transition: all 0.2s ease;
	position: relative;
}

.type-card:hover {
	border-color: var(--v-primary-base);
}

.type-card--selected {
	border-color: var(--v-primary-base);
	border-width: 2px;
}

.selected-badge {
	position: absolute;
	top: 8px;
	right: 8px;
}
</style>
